// src/Routes/AdminRoutes.js
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedComponent } from '../Pages/Authentication';
import { AdminHome, DonorManagement, DonorReport, AdministrativeSettings } from '../Pages/Admin';
import NotFoundPage from '../Components/NotFoundPage';
import AdminManagement from '../Pages/Admin/AdministrativeSettings/AdminManagement';
import AddAdmin from '../Pages/Admin/AdministrativeSettings/AddAdmin';
import AdminProfile from '../Pages/Admin/AdministrativeSettings/AdminProfile';
import { GlobalInfo } from '../Contexts/GlobalContext';
import RequestorManagement from '../Pages/Admin/AdministrativeSettings/RequestorManagement/RequestorManagement';
import LabManagement from '../Pages/Admin/AdministrativeSettings/Labs/LabManagement';
import LabHolidayEdit from '../Pages/Admin/AdministrativeSettings/Labs/Edit/LabHolidayEdit';
import LabEdit from '../Pages/Admin/AdministrativeSettings/Labs/Edit/LabEdit';
import LabAdd from '../Pages/Admin/AdministrativeSettings/Labs/Add/LabAdd';
import LabHolidayAdd from '../Pages/Admin/AdministrativeSettings/Labs/Add/LabHolidayAdd';
import AddRequestor from '../Pages/Admin/AdministrativeSettings/RequestorManagement/AddRequestor';
import RequestorProfile from '../Pages/Admin/AdministrativeSettings/RequestorManagement/RequestorProfile';
import DonorProfile from '../Pages/Admin/DonorManagement/DonorProfile';
import ViewSampleRequestDetails from '../Pages/Admin/SampleRequests/ViewSampleRequestDetails';
import AppointmentDurationCompensationManagment from '../Pages/Admin/AdministrativeSettings/AppointmentDurationsCompensation/AppointmentDurationCompensationManagment';
import EmailSMSManagement from '../Pages/Admin/AdministrativeSettings/Email-SMS-Management/EmailSMSManagement';
import AddEmailTemplate from '../Pages/Admin/AdministrativeSettings/Email-SMS-Management/AddEmailTemplate';
import DonationReport from '../Pages/Admin/DonationReports/DonationReports';
import AddPharma from '../Pages/Admin/AdministrativeSettings/RequestorManagement/AddPharma';
import AddCampus from '../Pages/Admin/AdministrativeSettings/RequestorManagement/AddCampus';
// import AddSeller from '../Pages/Admin/AddSeller';

const AdminRoutes = () => {
  const { isSidebarVisible } = useContext(GlobalInfo);
  const { isRestrictedPage  } = useContext(GlobalInfo);
  return (
    <div className={`${!isRestrictedPage ? 'el-middle' : ''} ${!isSidebarVisible ? 'collapsed-body' : ''}`}>
      <Routes>
        <Route path="dashboard" element={<AdminHome requiredRole="admin" />} />
        <Route path="sample-requests" element={<AdminHome requiredRole="admin" />} />
        <Route path="dashboard/viewdetails" element={<ViewSampleRequestDetails requiredRole="admin" />} />
        <Route path="dashboard/collectsamples" element={<ViewSampleRequestDetails requiredRole="admin" />} />
        <Route path="sample-requests/viewdetails" element={<ViewSampleRequestDetails requiredRole="admin" />} />
        <Route path="sample-requests/collectsamples" element={<ViewSampleRequestDetails requiredRole="admin" />} />
        {/* <Route path="sample-requests" element={<AdminHome requiredRole="admin" />} /> */}
        {/* <Route path="admin-home" element={<ProtectedComponent Component={AdminHome} requiredRole="admin" />} /> */}
        <Route path="donor-management" element={<DonorManagement requiredRole="admin" />} />
        <Route path="donor-management/donor-profile" element={<DonorProfile requiredRole="admin"/>} />

        <Route path="donation-reports" element={<DonationReport requiredRole="admin" />} />

        {/* <Route path="donation-reports" element={<DonorReport requiredRole="admin" />} /> */}
        <Route path="administrative-settings" element={<AdministrativeSettings requiredRole="admin" />} />
        <Route path="/admin-management" element={<AdminManagement requiredRole="admin" />} />
        <Route path="/admin-management/add-admin/:type" element={<AddAdmin requiredRole="admin" />} />
        {/* <Route path="/admin-management/admin-profile/:id" element={<AdminProfile requiredRole="admin" />} /> */}
        <Route path="/admin-management/admin-profile" element={<AdminProfile requiredRole="admin" />} />

        <Route path="/pharma-management" element={<RequestorManagement requiredRole="admin" />} />

        <Route path="/lab-hours" element={<LabManagement requiredRole="admin" />} />
        <Route path="/lab-hours/lab-holiday/add" element={<LabHolidayAdd requiredRole="admin" />} />
        <Route path="/lab-hours/lab-holiday/edit/:id" element={<LabHolidayEdit requiredRole="admin" />} />
        <Route path="/lab-hours/add" element={<LabAdd requiredRole="admin" />} />
        <Route path="/lab-hours/edit/:id" element={<LabEdit requiredRole="admin" />} />

        <Route path="/appointment-durations-and-compensation" element={<AppointmentDurationCompensationManagment requiredRole="admin" />} />

        <Route path="/email-sms-management" element={<EmailSMSManagement requiredRole="admin" />} />
        <Route path="/email-sms-management/add-template/:useType" element={<AddEmailTemplate requiredRole="admin" />} />

        <Route path="/pharma-management/add-requestor" element={<AddRequestor requiredRole="admin" />} />
        <Route path="/pharma-management/add-pharma" element={<AddPharma requiredRole="admin" />} />
        <Route path="/pharma-management/add-campus" element={<AddCampus requiredRole="admin" />} />
        {/* <Route path="/pharma-management/requestor-profile/:id" element={<RequestorProfile requiredRole="admin" />} /> */}
        <Route path="/pharma-management/requestor-profile" element={<RequestorProfile requiredRole="admin" />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default AdminRoutes;
